<nav class="sm:h-[6.8rem] h-[10rem] w-full py-[2rem] sm:py-[1rem] sm:px-[9.6rem] px-[7rem]"
  aria-label="Breadcrumb navigation">
  <div class="sm:h-[4.8rem] h-full self-center flex gap-[2.4rem] items-center">
    <a routerLink="/home"
      class="cursor-pointer border-solid border-black border-[0.2rem] rounded-full size-[3.4rem] flex items-center justify-center"
      aria-label="Back to home">
      <dsr-icon name="arrow-left-2" class="sm:!size-[2.4rem] !min-w-[1rem] !min-h-[1rem]" aria-hidden="true"></dsr-icon>
    </a>
    <ol class="dsr-typescale-body-small flex items-center gap-[0.8rem] list-none">
      <li>
        <a routerLink="/home" class="cursor-pointer dsr-typescale-body-small" tabindex="0">
          <span class="!underline dsr-typescale-body-small">{{ "HOME_LABEL" | translate }}</span>
        </a>
      </li>
      @for (item of items; track item; let last = $last) {
        <li class="flex w-fit gap-[0.8rem]">
          <span class="dsr-typescale-body-small" aria-hidden="true">
            /
          </span>
          <span class="dsr-typescale-body-small" [attr.aria-current]="last ? 'page' : null">
            {{ item }}
          </span>
        </li>
      }
    </ol>
  </div>
</nav>